import React from "react";
import { Users } from "lucide-react";

const EmptyCandidates = () => {
    return (
        <div className="grid grid-cols-1 gap-4 overflow-hidden h-[450px] p-6 pr-[17px]">
            <div className="flex flex-col items-center justify-center h-full text-center py-12 space-y-2 sm:space-y-3">
                <Users className="w-16 h-16 opacity-50 mb-3" />
                <p className="text-[14px font-medium">
                    No candidates found
                </p>
                <p className="text-[12px]">
                    Try adjusting your search or filters
                </p>
            </div>
        </div>
    );
};

export default EmptyCandidates;
